<div class="section-in-progress" *ngIf="cmaState.isLoadingReport">
  <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
  {{ cmaState.loadingMessage }}
</div>

<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->

  <div class="dash_base" *ngIf="!this.cmaState.openValueAdjustmentsValue">
    <div class="container-fluid mt-3">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row">
            <div class="col-md-12">
              <div class="comp-header">
                <h5 class="title mb-2">
                  <mat-icon class="mat-icon" (click)="close()"> arrow_back </mat-icon>Initial/Modified Search
                </h5>
                <div class="actions" *ngIf="!isFetchComps">
                  <!-- <button color="primary" mat-flat-button class="ml-2 net-seller" (click)="openNetSeller()">
                    Net Seller Proceeds
                  </button> -->
                  <button color="primary" mat-flat-button class="ml-2 net-seller" (click)="valueAdjustment()">
                    Make Adjustments
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-sm-6 col-12 map m-map">
              <app-geometry-map
                *ngIf="showMap && cmaReportData && showRadius == true"
                [zoom]="roiFilterForm?.get('radius')?.value ? roiFilterForm?.get('radius')?.value + 1 : 6"
                [center]="{
                  lat: cmaReportData.subject?.Latitude,
                  lng: cmaReportData.subject?.Longitude
                }"
                [radius]="roiFilterForm?.get('radius')?.value ? roiFilterForm?.get('radius')?.value : 1"
                [markerList]="markerList"
                [hideControls]="true"
                [hideLegend]="true"
              ></app-geometry-map>
              <app-geometry-map
                *ngIf="showMap && cmaReportData && showPolygon == true"
                [zoom]="13"
                [center]="{
                  lat: cmaReportData.subject?.Latitude,
                  lng: cmaReportData.subject?.Longitude
                }"
                [multiPolygon]="selectedPolygons?.length > 0 ? selectedPolygons : []"
                [markerList]="markerList"
                [hideControls]="true"
                [hideLegend]="true"
              ></app-geometry-map>
            </div>

            <div class="col-md-8 col-sm-6 pl-0">
              <div class="row">
                <div class="col-md-12 col-sm-12 pl-0">
                  <!-- *ngIf="lComparables && lComparables.length" -->
                  <div class="">
                    <div class="table-responsive prop-list" *ngIf="isScreenWidthLarge && !isFetchComps">
                      <table>
                        <thead class="prop-head">
                          <tr>
                            <td>
                              <mat-checkbox
                                color="primary"
                                (click)="$event.stopPropagation()"
                                [checked]="selectAllComps"
                                (change)="toggleSelectAllComps($event)"
                                aria-label="Select all rows"
                              ></mat-checkbox>
                            </td>
                            <td>#</td>
                            <td class="ads-sticky">Image</td>
                            <td class="ads-sticky" (click)="sort('UnparsedAddress')">
                              Address
                              <span *ngIf="sortColumnStatus['UnparsedAddress'] !== undefined">
                                <i *ngIf="sortColumnStatus['UnparsedAddress']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['UnparsedAddress']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('StandardStatus')">
                              Status
                              <span *ngIf="sortColumnStatus['StandardStatus'] !== undefined">
                                <i *ngIf="sortColumnStatus['StandardStatus']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['StandardStatus']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('ListPrice')">
                              List Price
                              <span *ngIf="sortColumnStatus['ListPrice'] !== undefined">
                                <i *ngIf="sortColumnStatus['ListPrice']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['ListPrice']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" width="15%">List Date</td>
                            <td class="ads-sticky" (click)="sort('ClosePrice')">
                              Sold Price
                              <span *ngIf="sortColumnStatus['ClosePrice'] !== undefined">
                                <i *ngIf="sortColumnStatus['ClosePrice']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['ClosePrice']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('CloseDate')">
                              Sold Date
                              <span *ngIf="sortColumnStatus['CloseDate'] !== undefined">
                                <i *ngIf="sortColumnStatus['CloseDate']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['CloseDate']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('Bed')">
                              Bed
                              <span *ngIf="sortColumnStatus['Bed'] !== undefined">
                                <i *ngIf="sortColumnStatus['Bed']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['Bed']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('Bath')">
                              Bath
                              <span *ngIf="sortColumnStatus['Bath'] !== undefined">
                                <i *ngIf="sortColumnStatus['Bath']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['Bath']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('LivingArea')">
                              GLA (sq.ft)
                              <span *ngIf="sortColumnStatus['LivingArea'] !== undefined">
                                <i *ngIf="sortColumnStatus['LivingArea']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['LivingArea']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('LotSize')">
                              Lot Size (sq.ft)
                              <span *ngIf="sortColumnStatus['LotSize'] !== undefined">
                                <i *ngIf="sortColumnStatus['LotSize']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['LotSize']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('Distance')">
                              Distance
                              <span *ngIf="sortColumnStatus['Distance'] !== undefined">
                                <i *ngIf="sortColumnStatus['Distance']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['Distance']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                            <td class="ads-sticky" (click)="sort('SimilarityScore')">
                              Similarity
                              <span *ngIf="sortColumnStatus['SimilarityScore'] !== undefined">
                                <i *ngIf="sortColumnStatus['SimilarityScore']" class="arrow-up">&#9650;</i>
                                <i *ngIf="!sortColumnStatus['SimilarityScore']" class="arrow-down">&#9660;</i>
                              </span>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="fixed-row">
                            <td></td>
                            <td>S</td>
                            <td>
                              <img
                                *ngIf="cmaReportData?.subject?.ListingId; else noImage"
                                [src]="
                                  listingImageBaseUrl +
                                  '?ListingId=' +
                                  (cmaReportData?.subject?.ListingId || null) +
                                  '&imageName=1&height=100'
                                "
                                alt="Image"
                                width="50"
                              />
                              <ng-template #noImage>--</ng-template>
                            </td>
                            <td class="address" (click)="viewComps(cmaReportData?.subject)">
                              <div class="d-inline-block" style="line-height: 18px">
                                <div>
                                  {{
                                    cmaReportData?.subject?.UnparsedAddress
                                      ? cmaReportData?.subject?.UnparsedAddress
                                      : ''
                                  }}
                                  <br />
                                  <small
                                    >{{ cmaReportData?.subject?.City ? cmaReportData?.subject?.City : '' }},
                                    {{
                                      cmaReportData?.subject?.StateOrProvince
                                        ? cmaReportData?.subject?.StateOrProvince
                                        : ''
                                    }}
                                    {{
                                      cmaReportData?.subject?.PostalCode ? cmaReportData?.subject?.PostalCode : ''
                                    }}</small
                                  >
                                </div>
                              </div>
                            </td>
                            <td>
                              <!-- class="prop-status" -->

                              <span
                                [ngClass]="{
                                  'sold-status': cmaReportData?.subject?.StandardStatus === 'Sold',
                                  'active-status':
                                    cmaReportData?.subject?.StandardStatus === 'Active' ||
                                    cmaReportData?.subject?.StandardStatus === 'Active UC' ||
                                    cmaReportData?.subject?.StandardStatus === 'Active Under Contract' ||
                                    cmaReportData?.subject?.StandardStatus === 'Pending',
                                  'cancel-status': cmaReportData?.subject?.StandardStatus === 'Cancel/Withdrawn',
                                  'expired-status': cmaReportData?.subject?.StandardStatus === 'Expired'
                                }"
                                >{{
                                  cmaReportData?.subject?.StandardStatus ? cmaReportData?.subject?.StandardStatus : '--'
                                }}</span
                              >
                            </td>

                            <td>
                              {{
                                cmaReportData?.subject?.ListPrice
                                  ? '$' + (cmaReportData?.subject?.ListPrice | number)
                                  : '--'
                              }}
                            </td>
                            <td>
                              {{
                                cmaReportData?.subject?.ListingContractDate
                                  ? (cmaReportData?.subject?.ListingContractDate | date: 'MM/dd/yy')
                                  : '--'
                              }}
                            </td>
                            <td>
                              {{
                                cmaReportData?.StandardStatus === 'Sold' && cmaReportData?.subject?.ClosePrice
                                  ? '$' + (cmaReportData?.subject?.ClosePrice | number)
                                  : '--'
                              }}
                            </td>
                            <td class="PriceWidth">
                              {{
                                cmaReportData?.subject?.CloseDate
                                  ? (cmaReportData?.subject?.CloseDate | date: 'MM/dd/yy')
                                  : '--'
                              }}
                            </td>
                            <td>
                              {{
                                cmaReportData?.subject?.BedroomsTotal
                                  ? (cmaReportData?.subject?.BedroomsTotal | number)
                                  : '--'
                              }}
                            </td>
                            <td>
                              {{
                                cmaReportData?.subject?.BathroomsDecimal
                                  ? (cmaReportData?.subject?.BathroomsDecimal | number)
                                  : '--'
                              }}
                            </td>
                            <td>
                              {{
                                cmaReportData?.subject?.LivingArea
                                  ? (cmaReportData?.subject?.LivingArea | number)
                                  : '--'
                              }}
                            </td>
                            <td>
                              {{
                                cmaReportData?.subject?.LotSizeSquareFeet
                                  ? (cmaReportData?.subject?.LotSizeSquareFeet | number)
                                  : '--'
                              }}
                            </td>
                            <td>0</td>
                            <td>100</td>
                          </tr>
                          <tr *ngFor="let comps of lComparables; let i = index">
                            <td>
                              <mat-checkbox
                                color="primary"
                                (click)="$event.stopPropagation()"
                                (change)="toggleSelect(comps, i, $event)"
                                [checked]="comps?.isSelected"
                              ></mat-checkbox>
                            </td>
                            <td>{{ comps.index }}</td>
                            <td>
                              <img
                                *ngIf="comps?.ListingId; else noImage"
                                [src]="
                                  listingImageBaseUrl + '?ListingId=' + comps?.ListingId + '&imageName=1&height=100'
                                "
                                alt="Image"
                                width="50"
                                height="50"
                                class="img-fluid fixed-image"
                              />
                              <ng-template #noImage>--</ng-template>
                            </td>
                            <td class="address" (click)="viewComps(comps)">
                              <div class="d-inline-block" style="line-height: 18px">
                                <div>
                                  {{ comps?.UnparsedAddress ? comps?.UnparsedAddress : '--' }}
                                  <br />
                                  <small
                                    >{{ comps?.City ? comps?.City : '--' }},
                                    {{ comps?.StateOrProvince ? comps?.StateOrProvince : '--' }}
                                    {{ comps?.PostalCode ? comps?.PostalCode : '--' }}</small
                                  >
                                </div>
                              </div>
                            </td>
                            <td>
                              <p
                                [ngClass]="{
                                  'sold-status': comps?.StandardStatus === 'Sold',
                                  'active-status':
                                    comps?.StandardStatus === 'Active' ||
                                    comps?.StandardStatus === 'Active UC' ||
                                    comps?.StandardStatus === 'Active Under Contract' ||
                                    comps?.StandardStatus === 'Pending',
                                  'cancel-status': comps?.StandardStatus === 'Cancel/Withdrawn',
                                  'expired-status': comps?.StandardStatus === 'Expired'
                                }"
                              >
                                {{ comps?.StandardStatus ? comps?.StandardStatus : '--' }}
                              </p>
                            </td>

                            <td>
                              {{ comps?.ListPrice ? '$' + (comps?.ListPrice | number) : '--' }}
                            </td>
                            <td>
                              {{
                                comps?.StandardStatus === 'Sold'
                                  ? '--'
                                  : comps?.ListingContractDate
                                  ? (comps?.ListingContractDate | date: 'MM/dd/yy')
                                  : '--'
                              }}
                            </td>
                            <td>
                              {{
                                comps?.StandardStatus === 'Sold' && comps?.ClosePrice
                                  ? '$' + (comps?.ClosePrice | number)
                                  : '--'
                              }}
                            </td>
                            <td class="PriceWidth">
                              {{
                                comps?.StandardStatus === 'Sold' && comps?.CloseDate
                                  ? (comps?.CloseDate | date: 'MM/dd/yy')
                                  : '--'
                              }}
                            </td>
                            <td>
                              {{ comps?.BedroomsTotal ? (comps?.BedroomsTotal | number) : '--' }}
                            </td>
                            <td>
                              {{ comps?.BathroomsDecimal ? (comps?.BathroomsDecimal | number) : '--' }}
                            </td>
                            <td>
                              {{ comps?.LivingArea ? (comps?.LivingArea | number) : '--' }}
                            </td>
                            <td>
                              {{ comps?.LotSizeSquareFeet ? (comps?.LotSizeSquareFeet | number) : '--' }}
                            </td>
                            <td>
                              {{ comps?.Distance ? (comps?.Distance | number) : '--' }}
                            </td>
                            <td>
                              {{ comps?.SimilarityScore ? (comps?.SimilarityScore | number) : '--' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div *ngIf="isFetchComps" class="fetch-comps pl-3">
                      <form [formGroup]="roiFilterForm">
                        <div
                          style="
                            background-color: #faffff;
                            padding: 20px;
                            border: 2px solid var(--global-color-secondary) !important;
                          "
                        >
                          <h4 class="text-left">Custom Search</h4>
                          <mat-button-toggle-group class="my-3" name="mapStyle" #group="matButtonToggleGroup">
                            <mat-button-toggle value="radius" (change)="mapOption($event.value)"
                              >Radius</mat-button-toggle
                            >
                            <mat-button-toggle value="polygon" (change)="mapOption($event.value)"
                              >Polygon</mat-button-toggle
                            >
                          </mat-button-toggle-group>
                          <button
                            mat-stroked-button
                            value="redrawPolygon"
                            class="redraw-btn"
                            *ngIf="selectedPolygons.length != 0"
                            (click)="mapOption('redrawPolygon')"
                          >
                            Redraw Polygon
                          </button>
                          <div class="pt-2" *ngIf="selectedOptionForMap == 'radius' || showRadius == true">
                            <div class="row">
                              <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-2 d-flex align-items-start">
                                <mat-form-field class="small-form-field w-100">
                                  <mat-label>Radius</mat-label>
                                  <input
                                    matInput
                                    type="number"
                                    min="1"
                                    max="5"
                                    formControlName="radius"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46"
                                  />
                                  <span matSuffix>miles</span>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="pt-2">
                            <div class="row">
                              <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                                <mat-form-field class="small-form-field w-100">
                                  <mat-label>Months Back</mat-label>
                                  <input
                                    matInput
                                    type="number"
                                    min="1"
                                    max="24"
                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                    formControlName="monthsBack"
                                  />
                                  <span matSuffix>months</span>
                                </mat-form-field>
                              </div>

                              <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                                <mat-form-field class="small-form-field w-100">
                                  <mat-label>Property Type</mat-label>
                                  <mat-select
                                    formControlName="propertySubType"
                                    panelClass="narrow-select-panel"
                                    multiple
                                  >
                                    <mat-option *ngFor="let option of filteredPropertyTypeOptions" [value]="option">
                                      {{ option }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>

                          <div class="pt-2">
                            <!-- Bed -->
                            <div class="row">
                              <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                                <mat-label>Bed</mat-label>
                                <div class="row mt-2">
                                  <mat-form-field class="col-lg-6 col-6">
                                    <mat-label>Min</mat-label>
                                    <mat-select formControlName="minBeds">
                                      <mat-option
                                        *ngFor="let value of filterConfig?.bedBathDropdownValues"
                                        [value]="value"
                                      >
                                        {{ value }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  <mat-form-field class="col-lg-6 col-6">
                                    <mat-label>Max</mat-label>
                                    <mat-select formControlName="maxBeds">
                                      <mat-option
                                        *ngFor="let value of filterConfig?.bedBathDropdownValues"
                                        [value]="value"
                                      >
                                        {{ value }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  <mat-error
                                    *ngIf="
                                      roiFilterForm.get('minBeds').hasError('maxBeds') ||
                                      roiFilterForm.get('maxBeds').hasError('minMaxError')
                                    "
                                    class="text-danger"
                                  >
                                    Min value should not be greater than max value
                                  </mat-error>
                                </div>
                              </div>

                              <!-- Bath -->
                              <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                                <mat-label>Bath</mat-label>
                                <div class="row mt-2">
                                  <mat-form-field class="col-lg-6 col-6">
                                    <mat-label>Min</mat-label>
                                    <mat-select formControlName="minBaths">
                                      <mat-option
                                        *ngFor="let value of filterConfig?.bedBathDropdownValues"
                                        [value]="value"
                                      >
                                        {{ value }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  <mat-form-field class="col-6">
                                    <mat-label>Max</mat-label>
                                    <mat-select formControlName="maxBaths">
                                      <mat-option
                                        *ngFor="let value of filterConfig?.bedBathDropdownValues"
                                        [value]="value"
                                      >
                                        {{ value }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  <mat-error
                                    *ngIf="
                                      roiFilterForm.get('minBaths').hasError('maxBaths') ||
                                      roiFilterForm.get('maxBaths').hasError('minMaxError')
                                    "
                                    class="text-danger"
                                  >
                                    Min value should not be greater than max value
                                  </mat-error>
                                </div>
                              </div>
                            </div>

                            <!-- Living Area -->
                            <div class="row">
                              <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                                <mat-label>Living Area (sqft.)</mat-label>
                                <div class="row mt-2">
                                  <mat-form-field class="col-lg-6 col-6">
                                    <input
                                      formControlName="minLivingArea"
                                      tabindex="6"
                                      matInput
                                      type="number"
                                      placeholder="Min"
                                      autocomplete="off"
                                    />
                                  </mat-form-field>
                                  <mat-form-field class="col-lg-6 col-6">
                                    <input
                                      formControlName="maxLivingArea"
                                      tabindex="6"
                                      matInput
                                      type="number"
                                      placeholder="Max"
                                      autocomplete="off"
                                    />
                                  </mat-form-field>
                                  <mat-error
                                    *ngIf="
                                      roiFilterForm.get('minLivingArea').hasError('maxLivingArea') ||
                                      roiFilterForm.get('maxLivingArea').hasError('minMaxError')
                                    "
                                    class="text-danger"
                                  >
                                    Min value should not be greater than max value
                                  </mat-error>
                                </div>
                              </div>

                              <!-- Year Built -->
                              <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                                <mat-label>Year Built</mat-label>
                                <div class="row mt-2">
                                  <mat-form-field class="col-6">
                                    <mat-label>Min</mat-label>
                                    <input
                                      formControlName="minYearBuilt"
                                      tabindex="6"
                                      matInput
                                      type="number"
                                      min="1000"
                                      placeholder="YYYY"
                                      autocomplete="off"
                                      (input)="
                                        validateYear($event.target, 'minYearBuilt', 'minYearBuilt', 'maxYearBuilt')
                                      "
                                    />
                                  </mat-form-field>
                                  <mat-form-field class="col-6">
                                    <mat-label>Max</mat-label>
                                    <input
                                      tabindex="7"
                                      matInput
                                      type="number"
                                      min="1000"
                                      [max]="currentYear"
                                      placeholder="YYYY"
                                      autocomplete="off"
                                      formControlName="maxYearBuilt"
                                      (input)="
                                        validateYear($event.target, 'maxYearBuilt', 'minYearBuilt', 'maxYearBuilt')
                                      "
                                    />
                                  </mat-form-field>
                                  <mat-error
                                    *ngIf="
                                      roiFilterForm.get('maxYearBuilt')?.errors?.invalidYear ||
                                      roiFilterForm.get('minYearBuilt')?.errors?.invalidYear
                                    "
                                  >
                                    Please enter a valid year (1000 - {{ currentYear }})
                                  </mat-error>
                                  <mat-error
                                    *ngIf="
                                      roiFilterForm.get('maxYearBuilt')?.errors?.maxMinYear ||
                                      roiFilterForm.get('minYearBuilt')?.errors?.maxMinYear
                                    "
                                  >
                                    Min value should not be greater than max value
                                  </mat-error>
                                </div>
                              </div>
                            </div>

                            <!-- Checkboxes & Notes -->
                            <div class="row">
                              <div class="col-12 col-md-12 include-checkbox">
                                <mat-checkbox
                                  class="w-100 no-wrap-checkbox"
                                  color="primary"
                                  formControlName="includeBelowGradedForFetchComps"
                                >
                                  Include below grade area in comparable similarity scoring
                                </mat-checkbox>
                              </div>
                              <div class="col-12 mb-3">
                                <p class="fst-italic">
                                  Comps are scored for similarity based on Living Area, Age, Sold Date, Number of Units
                                  (for multi-family searches), and Distance from the subject property.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="justify-content-between align-items-center" *ngIf="!isFetchComps">
                      <mat-paginator
                        #paginator
                        [pageSizeOptions]="[10, 20]"
                        showFirstLastButtons
                        class="d-inline-block m-wdh"
                        class="my-1 pagination roi-pg"
                        [length]="listOfComparables?.length"
                        [pageIndex]="pageIndex"
                        (page)="pageChange($event)"
                        showFirstLastButtons
                      >
                      </mat-paginator>
                    </div>
                    <div class="justify-content-between align-items-center"></div>
                  </div>
                </div>
              </div>

              <div class="row mb-2 mt-1" *ngIf="!isScreenWidthLarge">
                <div class="col-md-6 col-sm-6 col-12 mx-2" *ngFor="let comps of lComparables; let i = index">
                  <mat-card class="report-card1 mb-3">
                    <mat-card-content>
                      <mat-card-title>
                        <div class="row">
                          <div class="col-6">
                            <mat-checkbox
                              color="primary"
                              (click)="$event.stopPropagation()"
                              (change)="toggleSelect(comps, i, $event)"
                              [checked]="comps?.isSelected"
                            ></mat-checkbox>
                          </div>
                        </div>
                        <div class="row" (click)="viewComps(comps)">
                          <div class="col-6">
                            <img
                              *ngIf="comps?.ListingId; else noImage"
                              [src]="listingImageBaseUrl + '?ListingId=' + comps?.ListingId + '&imageName=1&height=100'"
                              alt="Image"
                              class="img-fluid"
                            />
                            <ng-template #noImage>--</ng-template>
                          </div>
                          <div class="col-6 pr-1 pl-0">
                            <h5 class="prop-address mb-1">
                              {{ comps?.UnparsedAddress ? comps?.UnparsedAddress : '--' }}
                              {{ comps?.City ? comps?.City : '--' }}, <br /><span class="sub-address"
                                >{{ comps?.StateOrProvince ? comps?.StateOrProvince : '--' }}
                                {{ comps?.PostalCode ? comps?.PostalCode : '--' }}
                              </span>
                            </h5>
                            <p class="comparables-details mb-1">
                              Dist: <b>{{ comps?.Distance ? (comps?.Distance | number) : '--' }}</b>
                            </p>
                            <h5 class="val-P">
                              <span class="prop-status">{{
                                comps?.StandardStatus ? comps?.StandardStatus : '--'
                              }}</span>
                            </h5>
                          </div>
                        </div>

                        <div class="row comparables-details mt-2">
                          <div class="col-6">
                            <div>
                              GLA (sq.ft):
                              <b>{{ comps?.LivingArea ? (comps?.LivingArea | number) : '--' }}</b>
                            </div>

                            <div>
                              Lot Size (sq.ft):
                              <b> {{ comps?.LotSizeSquareFeet ? (comps?.LotSizeSquareFeet | number) : '--' }}</b>
                            </div>

                            <div>
                              Similarity:
                              <b> {{ comps?.SimilarityScore ? (comps?.SimilarityScore | number) : '--' }}</b>
                            </div>
                            <div>
                              Bed:
                              <b>{{ comps?.BedroomsTotal ? (comps?.BedroomsTotal | number) : '--' }}</b>
                            </div>
                            <div>
                              Bath: <b> {{ comps?.BathroomsDecimal ? (comps?.BathroomsDecimal | number) : '--' }}</b>
                            </div>
                          </div>
                          <div class="col-6 pl-0">
                            <div>
                              List Date:
                              <b>
                                {{
                                  comps?.StandardStatus === 'Sold'
                                    ? '--'
                                    : comps?.ListingContractDate
                                    ? (comps?.ListingContractDate | date: 'MM/dd/yy')
                                    : '--'
                                }}</b
                              >
                            </div>
                            <div>
                              Close Date:
                              <b>
                                {{
                                  comps?.StandardStatus === 'Sold' && comps?.CloseDate
                                    ? (comps?.CloseDate | date: 'MM/dd/yy')
                                    : '--'
                                }}</b
                              >
                            </div>
                            <div>
                              List Price: <b>{{ comps?.ListPrice ? '$' + (comps?.ListPrice | number) : '--' }}</b>
                            </div>
                            <div>
                              Sold Price:
                              <b>
                                {{
                                  comps?.StandardStatus === 'Sold' && comps?.ClosePrice
                                    ? '$' + (comps?.ClosePrice | number)
                                    : '--'
                                }}</b
                              >
                            </div>
                          </div>
                        </div>
                      </mat-card-title>
                    </mat-card-content>
                  </mat-card>
                </div>
              </div>
            </div>
          </div>
          <div class="sticky-footer">
            <div class="row mx-0 w-100">
              <div class="col-md-12 col-sm-12 col-12 pr-2">
                <div class="d-md-flex align-items-center flex-wrap value-section">
                  <div class="d-md-flex">
                    <div class="">
                      <mat-checkbox
                        class="mr-3"
                        color="primary"
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelectValue('AVM_VALUE')"
                        [checked]="isFairValueSelected"
                        [disabled]="!cmaReportData?.homeValue?.avm?.value"
                      ></mat-checkbox>
                      <strong>Starting Value</strong>
                      <mat-icon [matTooltip]="'Derived from avm home value'" class="info-icon pl-1"> info </mat-icon>
                      :
                      <b>{{
                        cmaReportData?.homeValue?.avm?.value
                          ? '$' + (cmaReportData?.homeValue?.avm.value | number)
                          : '--'
                      }}</b>
                    </div>
                    <div
                      class="ml-md-3 ml-0 my-md-0 my-2 pipe-none"
                      style="font-size: 14px"
                      *ngIf="cmaReportData?.homeValue?.adjustedValue"
                    >
                      |
                    </div>

                    <div
                      class="ml-md-3 ml-0 my-md-0 my-2"
                      *ngIf="cmaReportData?.homeValue?.adjustedValue || adjustedFmvBySelectedComps"
                    >
                      <mat-checkbox
                        class="mr-3"
                        color="primary"
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelectValue('SALES_COMPARISON_VALUE')"
                        [checked]="isAdjustedValueSelected"
                      ></mat-checkbox>
                      <strong>Model Adjusted Value</strong>
                      <mat-icon
                        [matTooltip]="
                          showAdjustedFMV ? 'Derived from value adjustments' : 'Derived from selected comparables'
                        "
                        class="info-icon pl-1"
                      >
                        info
                      </mat-icon>
                      :
                      <b>{{
                        showAdjustedFMV
                          ? cmaReportData?.homeValue?.adjustedValue
                            ? '$' + (cmaReportData?.homeValue?.adjustedValue | number)
                            : '--'
                          : adjustedFmvBySelectedComps
                          ? '$' + (adjustedFmvBySelectedComps | number)
                          : '--'
                      }}</b>
                    </div>

                    <div class="ml-md-3 ml-0 my-md-0 my-2 pipe-none" style="font-size: 14px">|</div>

                    <div class="ml-md-3 ml-0 my-md-0 my-2 m-my-2">
                      <mat-checkbox
                        class="mr-3"
                        color="primary"
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelectValue('CUSTOM_VALUE')"
                        [checked]="isCustomValueSelected"
                      ></mat-checkbox>
                      <strong>Your Value</strong>
                      <mat-icon [matTooltip]="'Using Your Comp Inputs/Adjustments'" class="info-icon pl-1">
                        info
                      </mat-icon>
                      :
                      <!-- Input Field -->
                      <mat-form-field appearance="outline" class="compact-field" style="width: 150px">
                        <span matPrefix>$&nbsp;</span>
                        <input
                          matInput
                          type="text"
                          [(ngModel)]="customValueDisplay"
                          (ngModelChange)="onCustomValueInput($event)"
                          [disabled]="!isCustomValueSelected"
                          placeholder="Enter value"
                      /></mat-form-field>
                      <span class="primary saving ml-3" *ngIf="isSavingValue">
                        Updating<span class="dots"></span>
                      </span>
                    </div>
                  </div>

                  <div class="text-right m-buttons" *ngIf="!isFetchComps" style="line-height: normal">
                    <button
                      *ngIf="
                        comparablesBaskets.length && !arraysHaveSameElements(selectedComparablesId, savedComparablesId)
                      "
                      mat-stroked-button
                      color="primary"
                      type="button"
                      (click)="saveComparables('silent')"
                      class="mr-1 save-comparables"
                    >
                      <span
                        [matBadge]="selectedComparablesId.length"
                        matBadgeColor="warn"
                        matBadgePosition="above after"
                        matBadgeSize="small"
                        matBadgeOverlap="false"
                      >
                        Save Comparables
                      </span>
                    </button>

                    <button
                      mat-flat-button
                      color="primary"
                      class="primary float-right ml-auto fetch-comp"
                      (click)="fetchComps()"
                    >
                      Custom Search
                    </button>
                  </div>

                  <div class="text-right" *ngIf="isFetchComps">
                    <button mat-button type="button" (click)="closeDialog()">Cancel</button>
                    <button
                      class="ml-1"
                      type="submit"
                      cdkFocusInitial
                      mat-flat-button
                      [pmx-progress-button]="isFetchCompsInProgress"
                      color="primary"
                      (click)="fetchCompsSubmit()"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-value-adjustments
    [isEdit]="isEdit"
    [reportId]="reportId"
    [cmaReportId]="cmaReportId"
    [cmaReportData]="cmaReportData"
    (valuesAdjusted)="valuesAdjustedChange($event)"
    *ngIf="this.cmaState.openValueAdjustmentsValue"
  ></app-value-adjustments>
</div>

<!-- <app-net-seller
  (updateNetSeller)="onNetSellerDataChange($event)"
  *ngIf="cmaState.openNetSellerSheet | async"
></app-net-seller> -->

<div class="confirm-dialog">
  <ng-template #saveCompsDialog>
    <button class="close" mat-button type="button" (click)="closeSaveCompsDialog()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="addGroupWrap expand-dialog">
      <h2 matDialogTitle class="text-center">Save Selected Comps</h2>
      <div mat-dialog-content class="pt-2">Save selected comparables? Unsaved ones will be lost!</div>
      <mat-dialog-actions>
        <div class="w-100 text-right">
          <button class="ml-1" type="submit" cdkFocusInitial mat-stroked-button color="primary" (click)="skipSaving()">
            Skip
          </button>
          <button
            class="ml-1"
            type="submit"
            cdkFocusInitial
            mat-flat-button
            color="primary"
            (click)="saveCompsAndProceed()"
          >
            Save
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  </ng-template>
</div>

<div class="confirm-dialog">
  <ng-template #fetchCompsDialog>
    <button class="close" mat-button type="button" (click)="closeFetchCompsDialog()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="addGroupWrap expand-dialog">
      <h2 matDialogTitle class="text-center">Compare Comparables!!</h2>
      <div mat-dialog-content class="pt-2">
        Do you want to keep current {{ selectedComparablesId.length }} selected comparables?
      </div>
      <mat-dialog-actions>
        <div class="w-100 text-right">
          <button
            class="ml-1"
            type="submit"
            cdkFocusInitial
            mat-stroked-button
            color="primary"
            (click)="fetchComparables(false)"
          >
            No
          </button>
          <button
            class="ml-1"
            type="submit"
            cdkFocusInitial
            mat-flat-button
            color="primary"
            (click)="fetchComparables(true)"
          >
            Yes
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  </ng-template>
</div>
